import React, { useState, useCallback, useEffect } from 'react'
import apiCalls from 'src/api/apiCalls';
import ProgramsGridBar from './programsGridBar';
import Loader from '../loader.component';
import { Alert } from 'antd';
const ProgramsdGrid = ((props) => {
  const [copiedId, setCopiedId] = useState('');
  const [programsData, setProgramsData] = useState([])
  const [loader, setLoader] = useState(false)
  const [errorMsg, setErrorMsg] = useState(null)
  useEffect(() => {
    getProgramsData(props?.filterValues)
  }, [props?.filterValues])
  const getProgramsData = useCallback(async (values) => {
    setErrorMsg(null);
    setLoader(true);
    try {
      const response = await apiCalls.programsData(values?.programName, values?.currency, values?.state);
      if (response.ok) {
        setProgramsData(response?.data?.data);
      } else {
        setErrorMsg(apiCalls.isErrorDispaly(response?.data));
      }
    } catch (error) {
      setErrorMsg(error);
    } finally {
      setLoader(false);
    }
  }, []);

  const handleIdCopy = useCallback((id) => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])

  const closeErrorHandler = useCallback(() => {
    setErrorMsg(null)
  }, [])
  return (
    <div>
      {loader && <Loader />}
      {!loader && <div className=''>
        {errorMsg !== null && (
          <Alert
            className='mb-6'
            type="error"
            description={errorMsg}
            onClose={closeErrorHandler}
            showIcon
            closable
          />
        )}
        <ProgramsGridBar data={programsData} copied={copiedId} handleCopy={handleIdCopy} />
      </div>
      }
    </div>
  )
})
export default ProgramsdGrid
